import { useTheme } from "next-themes";
import { AnimateIcon } from "@/components/animate-ui/icons/icon";
import { MoonStar } from "@/components/animate-ui/icons/moon-star";
import { Sun } from "@/components/animate-ui/icons/sun";
import { SunMoon } from "@/components/animate-ui/icons/sun-moon";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ThemeToggle() {
	const { setTheme } = useTheme();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<AnimateIcon animateOnHover asChild>
					<Button variant="ghost" size="icon">
						<Sun className="size-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
						<MoonStar className="absolute size-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
						<span className="sr-only">Toggle theme</span>
					</Button>
				</AnimateIcon>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<AnimateIcon animateOnHover asChild>
					<DropdownMenuItem onClick={() => setTheme("light")}>
						<Sun className="mr-2 size-4" />
						Light
					</DropdownMenuItem>
				</AnimateIcon>
				<AnimateIcon animateOnHover asChild>
					<DropdownMenuItem onClick={() => setTheme("dark")}>
						<MoonStar className="mr-2 size-4" />
						Dark
					</DropdownMenuItem>
				</AnimateIcon>
				<AnimateIcon animateOnHover asChild>
					<DropdownMenuItem onClick={() => setTheme("system")}>
						<SunMoon className="mr-2 size-4" />
						System
					</DropdownMenuItem>
				</AnimateIcon>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
